import { Thead, Tr, Th } from '@patternfly/react-table'
import * as React from 'react'
import { useCallback } from 'react'

import type { ISorting } from '@app/lib/sorting'

const columnNames = [
  { title: 'MRN', value: 'mrn' },
  { title: 'Patient Name', value: 'patient_name' },
  { title: 'Birth Sex', value: 'birth_sex' },
  { title: 'Date of Birth', value: 'date_of_birth' },
]

export type ColumnHeader = {
  title: string
  value: string
  sortable: boolean
}

interface Props {
  addActionColumn?: boolean
  columnHeaders?: ColumnHeader[]
  sorting: ISorting
}

export const PatientListHeader = ({
  addActionColumn,
  columnHeaders,
  sorting,
}: Props) => {
  const { onSetSort, sortField, sortDirection } = sorting

  const onSort = useCallback(
    (_event, index, direction) => {
      const fieldName = columnNames.concat(columnHeaders)[index].value
      onSetSort(fieldName, direction)
    },
    [columnHeaders, onSetSort],
  )

  const allColumns = columnHeaders
    ? columnNames.concat(columnHeaders)
    : columnNames

  const sortIndex = allColumns.findIndex((it) => it.value === sortField)

  return (
    <Thead>
      <Tr>
        {columnNames.map((column, columnIndex) => {
          const sortParams = {
            sort: {
              sortBy: {
                index: sortIndex,
                direction: sortDirection,
              },
              onSort,
              columnIndex,
            },
          }

          return (
            <Th key={columnIndex} {...sortParams}>
              {column.title}
            </Th>
          )
        })}
        {columnHeaders?.map((columnHeader, index) => {
          const sortParams = columnHeader.sortable
            ? {
                sort: {
                  sortBy: {
                    index: sortIndex,
                    direction: sortDirection,
                  },
                  onSort,
                  columnIndex: columnNames.length + index,
                },
              }
            : {}
          const columnIndex = columnNames.length + index
          return (
            <Th key={columnIndex} {...sortParams}>
              {columnHeader.title}
            </Th>
          )
        })}
        {addActionColumn ? <Th>Actions</Th> : null}
      </Tr>
    </Thead>
  )
}
